module.exports = __webpack_public_path__ + "static/media/ai.96e24e9e.svg";